import { cn } from './cn.js';

/// A gota do HUE•System, a mesma do ícone da aba (`apps/web/public/favicon.svg`). As cores são
/// fixas: a marca do produto não segue a paleta da empresa nem o tema claro ou escuro.
export function HueMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn('size-5', className)} aria-hidden="true">
      <path
        d="M12 2.6S5.5 9.6 5.5 14.3c0 3.7 2.9 6.3 6.5 6.3s6.5-2.6 6.5-6.3C18.5 9.6 12 2.6 12 2.6Z"
        fill="#1c1c1e"
      />
      <circle cx="9.6" cy="14.4" r="1.75" fill="#ebddb4" />
    </svg>
  );
}

/// O bloco da marca: o fundo creme do ícone da aba com a gota no centro. O tamanho e o raio vêm de
/// `className` (por exemplo `size-9 rounded-xl`); a gota ocupa a proporção do favicon.
export function HueLogoTile({ className }: { className?: string }) {
  return (
    <span
      className={cn('hue-logo-tile grid size-9 shrink-0 place-items-center rounded-xl', className)}
    >
      <HueMark className="size-[82%]" />
    </span>
  );
}
